export const FETCH_NAVIGATION_LIST = 'FETCH_NAVIGATION_LIST';
export const SET_NAVIGATION_ITEM = 'SET_NAVIGATION_ITEM';
export const DELETE_NAVIGATION_ITEM = 'DELETE_NAVIGATION_ITEM';
export const RESET_NAVIGATION_LIST = 'RESET_NAVIGATION_LIST';

export default {
  FETCH_NAVIGATION_LIST,
  SET_NAVIGATION_ITEM,
  DELETE_NAVIGATION_ITEM,
  RESET_NAVIGATION_LIST,
};
